export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14152.8e9e46cf.jpg";